<template>
  <div class="line w-full h-full">
    <v-chart ref="myCharts" :options="options" class="w-full h-full" />
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/bar'

export default {
  components: {
    'v-chart': ECharts
  },
  props: {
    cData: {
      type: Array
    }
  },
  watch: {
    cData: function (val) {
      const clonstOptions = JSON.parse(JSON.stringify(this.options))
      const postData = {
        ...clonstOptions,
        series: [
          {
            ...clonstOptions.series[0],
            data: val,
          }
        ]
      }
      console.log(postData)
      this.options = postData
    }
  },
  data() {
    let max = Math.floor(Math.max(...this.cData) / 10) * 10 + 10;
    return {
      options: {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'max-width:60%;white-space:pre-wrap;'
        },
        // legend: {
        //   // data: this.cData.legend.data,
        //   data: ['选项一', '选项二'],
        //   itemGap: 3,
        //   itemWidth: 16,
        //   itemHeight: 8
        // },
        grid: {
          top: '30px',
          left: '60px',
          right: '80px',
          bottom: '30px'
        },
        // dataZoom: [
        //   {
        //     type: 'slider',
        //     // show: this.cData.xAxis.data.length > 9 ? true : false,
        //     show: false,
        //     realtime: true,
        //     start: 0,
        //     end: 100
        //   }
        // ],
        xAxis: {
          name:'',
          type: 'category',
          boundaryGap: false,
          // data: this.cData.xAxis.data,
          data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          axisLabel: {
            interval: 0,
            textStyle: {
              color: 'rgba(0,0,0,0.45)'
            },
            // formatter: function (value) {
            //   return value.length > 6 ? value.slice(0, 6) + '...' : value
            // }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(0,0,0,0.08)'
            }
          },
          nameTextStyle:{  //设置单位的样式
            color:'rgba(0,0,0,0.45)'
          },
          axisPointer: {
            triggerTooltip: true
          }
        },
        yAxis: {
          name:'',
          type: 'value',
          splitNumber:4,
          splitLine: {
            lineStyle: {  //y轴分隔线样式设置
              color: 'rgba(0,0,0,0.08)',   //颜色
            }
          },
          axisLabel: {
            textStyle: {
              color: 'rgba(0,0,0,0.45)'
            }
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: 'rgba(0,0,0,0.45)'
            }
          },
          axisTick: { //刻度设置
            show: false
          }
        },
        series: [
          {
            // data: [1000, 800,700,600,500,400,300,800,1300,500,900,1700],
            data: [],
            color: '#2775E8',
            name: '结算总费用',
            type: 'line',
            itemStyle:{ //这里设置的拐点颜色
              color: '#2775E8',
              borderColor:'#fff',
              borderWidth:1,
            },
            symbol: "circle",  //标记的图形（拐点）
            symbolSize: 8,
            areaStyle: {
              color: new ECharts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: 'rgba(39, 117, 232, 1)'
                },
                {
                  offset: 1,
                  color: 'rgba(39, 117, 232, 0)'
                }
              ])
            },

          }
        ]
      }
    }
  },
  methods: {
    resizeTheChart() {
      if (this.$refs.barEcharts) {
        this.$refs.barEcharts.resize()
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.resizeTheChart)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeTheChart)
  }
}
</script>

<style lang="scss" scoped>
.line {
  .echarts {
    width: 100%;
    height: 100%;
  }
}
</style>
